export const ARCGIS_PORTAL_URL = process.env.REACT_APP_PORTAL_URL ?? "";
export const ARCGIS_PORTAL_ITEM_ID =
  process.env.REACT_APP_ARCGIS_PORTAL_ITEM_ID ?? "";
export const ARCGIS_CLUSTERING_PORTAL_ITEM_ID =
  process.env.REACT_APP_ARCGIS_CLUSTERING_PORTAL_ITEM_ID ?? "";

export const UNEXAMINED_ZONE = process.env.REACT_APP_UNEXAMINED_ZONE ?? "";
export const EXAMINED_ZONE = process.env.REACT_APP_EXAMINED_ZONE ?? "";
export const OCCUPAID_ZONE = process.env.REACT_APP_OCCUPAID_ZONE ?? "";
export const DEFAULT_MAP_CENTER = {
  lat: 48.382959501624455,
  lng: 31.182243657670643,
};
